import { ENGLISH } from '@nexxt/common/constants';
import {
    HealthProblemContext,
    HealthProblem,
    HealthProblemType,
    ProjectLanguage
} from '@nexxt/common/types';
import { PROJECT_EDIT_MODES } from '../interface/project.interface';

export function sortHealthProblemByTab(projectHealth: HealthProblem[]) {
    let hasProblemInQuestion = null,
        hasProblemInAudience = null,
        hasProblemsInOverview = null;

    projectHealth.forEach((health) => {
        switch (health.context) {
            case HealthProblemContext.AUDIENCE:
                if (hasProblemInAudience) {
                    hasProblemInAudience =
                        hasProblemInAudience === health.problemType
                            ? health.problemType
                            : HealthProblemType.ERROR;
                } else {
                    hasProblemInAudience = health.problemType;
                }
                break;

            case HealthProblemContext.OVERVIEW:
                if (hasProblemsInOverview) {
                    hasProblemsInOverview =
                        hasProblemsInOverview === health.problemType
                            ? health.problemType
                            : HealthProblemType.ERROR;
                } else {
                    hasProblemsInOverview = health.problemType;
                }
                break;
            default:
                if (hasProblemInQuestion) {
                    hasProblemInQuestion =
                        hasProblemInQuestion === health.problemType
                            ? health.problemType
                            : HealthProblemType.ERROR;
                } else {
                    hasProblemInQuestion = health.problemType;
                }
                break;
        }
    });
    return {
        question: hasProblemInQuestion,
        audience: hasProblemInAudience,
        overview: hasProblemsInOverview
    };
}

export function sortHealthProblemByQuestionID(
    projectHealth: HealthProblem[],
    contextTypes: HealthProblemContext[] = [
        HealthProblemContext.CONDITION,
        HealthProblemContext.QUESTION,
        HealthProblemContext.OVERVIEW
    ],
    problemTypes: HealthProblemType[] = [
        HealthProblemType.ERROR,
        HealthProblemType.WARNING
    ]
): { [key: string]: { list: any[]; type: HealthProblemType } } {
    const formattedProjectHealth = projectHealth
        .filter((health) => contextTypes.includes(health.context))
        .filter((health) => problemTypes.includes(health.problemType))
        .reduce((arr, health, i) => {
            const key = health.questionRef || health?.details?.fieldName;
            if (arr[key]) {
                arr[key].type =
                    arr[key].type !== health.problemType
                        ? HealthProblemType.ERROR
                        : health.problemType;

                arr[key].list.push(health);
            } else {
                arr[key] = {
                    type: health.problemType,
                    list: [health]
                };
            }
            return arr;
        }, {});

    return formattedProjectHealth;
}

export function handleEditMode(editMode: PROJECT_EDIT_MODES): {
    overview: boolean;
    question: boolean;
    audience: boolean;
    settings: boolean;
} {
    switch (editMode) {
        case PROJECT_EDIT_MODES.DISABLED:
        case PROJECT_EDIT_MODES.TEMPLATE_MODE:
            return {
                overview: false,
                question: false,
                audience: false,
                settings: false
            };
        case PROJECT_EDIT_MODES.REPUBLISH:
            return {
                overview: true,
                question: true,
                audience: false,
                settings: true
            };
        default:
            return {
                overview: true,
                question: true,
                audience: true,
                settings: true
            };
    }
}

export function getMainLanguage(languages: ProjectLanguage[]) {
    const languageCodes = languages?.map((l) => l.value);

    return languageCodes.includes(ENGLISH) ? ENGLISH : languageCodes[0];
}
